module.exports = __webpack_public_path__ + "static/media/logo.f59c7c0c.png";